<div class="row d-flex flex-fill">
    <div class="col-sm-6 p-3" *ngIf="processedLines">
        <div class="grid-fill">
            <dx-data-grid
                #processedLinesGrid
                keyExpr="id"
                [dataSource]="processedLines"
                [showBorders]="true"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
            >
                <dxi-column dataField="id" caption="Id" width="50"></dxi-column>
                <dxi-column dataField="orderLineDetailId" caption="Detail Id" width="100"></dxi-column>
                <dxi-column dataField="orderLineDetail.orderLine.order.invoiceNumber" caption="SO#" width="100" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="orderLineDetail.orderLine.partNumber" caption="Part #" width="100"></dxi-column>
                <dxi-column dataField="dateTime" caption="Processed Time" dataType="datetime" width="150"></dxi-column>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-selection [mode]="'single'"></dxo-selection>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="process-queue-processed-grid"></dxo-state-storing>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="open(cell.data.orderLineDetail.orderLine.orderId)">{{ cell.value || '' }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button type="button" (click)="getData()" class="btn btn-primary ms-10">Refresh Data</button>
                </div>

                <div *dxTemplate="let data of 'toolbarTextBefore'">
                    <h4>Processed Lines</h4>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="processedLines" class="me-3"
                        ><strong>{{ processedLinesGrid.instance.totalCount() + ' items' }}</strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
    </div>
    <div class="col-sm-6 p-3 d-flex flex-column">
        <div class="grid-fill" *ngIf="unProcessedLines">
            <dx-data-grid
                #unProcessedLinesGrid
                [dataSource]="unProcessedLines"
                [showBorders]="true"
                keyExpr="id"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparing($event)"
            >
                <dxi-column dataField="id" caption="Id" width="50"></dxi-column>
                <dxi-column dataField="orderLine.order.invoiceNumber" caption="SO#" width="100" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="orderLine.partNumber" caption="Part #" width="300"></dxi-column>
                <dxi-column dataField="created" caption="Created" dataType="datetime" width="150"></dxi-column>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-selection [mode]="'single'"></dxo-selection>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="process-queue-current-grid"></dxo-state-storing>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="open(cell.data.orderLine.orderId)">{{ cell.value || '' }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'"></div>
                <div *dxTemplate="let data of 'toolbarTextBefore'">
                    <h4>UnProcessed Lines</h4>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="unProcessedLines" class="me-3"
                        ><strong>{{ unProcessedLinesGrid.instance.totalCount() + ' items' }}</strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
        <div class="grid-fill" *ngIf="poisonLines">
            <dx-data-grid #poisonLinesGrid [dataSource]="poisonLines" [showBorders]="true" keyExpr="id" [columnAutoWidth]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
                <dxi-column dataField="id" caption="Id" width="50"></dxi-column>
                <dxi-column dataField="orderLine.order.invoiceNumber" caption="SO#" width="100" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="orderLine.partNumber" caption="Part #" width="300"></dxi-column>
                <dxi-column dataField="created" caption="Created" dataType="datetime" width="150"></dxi-column>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-selection [mode]="'multiple'"></dxo-selection>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="process-queue-poison-grid"></dxo-state-storing>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="open(cell.data.orderLine.orderId)">{{ cell.value || '' }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'"></div>
                <div *dxTemplate="let data of 'toolbarTextBefore'">
                    <h4>Poison Lines</h4>
                </div>
                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="poisonLines" class="me-3"
                        ><strong>{{ poisonLinesGrid.instance.totalCount() + ' items' }}</strong></span
                    >
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
